import { FC, useEffect, useRef, useState } from 'react';
import './select.less';
import { SvgIcon } from '@/components';
import EventBus from 'js-event-bus';
import classnames from 'classnames';
const eventBus = new EventBus();

export interface SelectOptionProps {
  key: any; // 一般为id
  value: any; // 一般为值
}
export interface SelectProps {
  useAnimate?: boolean | string; // 启用下拉框淡入动画
  customContent?: React.ReactNode; // 自定义展示内容
  customSelectedIcon?: React.ReactNode; // 自定义选中的对勾icon
  className?: string; // 外部class
  optClassName?: string; // option的class
  multi?: boolean; //是否支持多选多选,多选时value或者selectedKeys为数组
  style?: React.CSSProperties;
  optStyle?: React.CSSProperties;
  value?: any | any[];
  disabled?: boolean;
  selectedKeys?: any | any[]; // selectedKeys出现的时候value失效 ，onChange的时候请用第二个参数key控制，
  onChange?: (value: any, key: any) => void;
  onFocus?: () => void;
  options?: SelectOptionProps[];
  /** 是否根据 options 是否有数据展现下拉 */
  slideDownByOptions?: boolean;
}

export const Select: FC<SelectProps> = ({
  useAnimate = 'fadeIn',
  customContent = null,
  customSelectedIcon = null,
  className = '',
  optClassName = '',
  multi = false,
  style = {},
  optStyle = {},
  options = [],
  slideDownByOptions = false,
  onChange = (item: any, key: any) => {},
  onFocus = () => {},
  value = '',
  disabled = false,
  selectedKeys,
}) => {
  const [slideDown, setSlideDown] = useState<boolean>(false);
  const idRef = useRef({ id: Math.random() });
  const animateRef: any = useRef(null);
  const id = idRef.current.id;
  const slideDownBusName = 'custom-select-event-slide-down';
  useEffect(() => {
    const fn = () => {
      setSlideDown(false);
    };
    document.body.addEventListener('click', fn, false);
    return () => {
      document.body.removeEventListener('click', fn, false);
    };
  }, []);
  useEffect(() => {
    if (slideDown) {
      const dom = animateRef.current;
      if (animateRef.current) {
        if (useAnimate) {
          dom.classList.add(useAnimate, 'animated');
        }
      }
    }
  }, [useAnimate, slideDown]);
  useEffect(() => {
    // 点击当前的select时候关闭其他select收起
    eventBus.on(slideDownBusName, (v: number) => {
      if (v !== id) {
        slideDown && setSlideDown(false);
      }
    });
  }, [id, slideDown]);

  useEffect(() => {
    if (slideDownByOptions && !disabled) {
      const shouldSlideDown = Array.isArray(options) && options.length > 0;
      setSlideDown(shouldSlideDown);
      shouldSlideDown && eventBus.emit(slideDownBusName, null, id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  return (
    <div
      className={classnames('custom-select-wrapper', className, {
        slideDown: slideDown,
        disabled: disabled,
      })}
      style={style}
      onClick={(e) => {
        eventBus.emit(slideDownBusName, null, id);
        onFocus();
        e.stopPropagation();

        const shouldSlideDown = slideDownByOptions
          ? Array.isArray(options) && options.length > 0
          : true;
        !disabled && setSlideDown(shouldSlideDown);
      }}
    >
      <div className="inner flex flex-between">
        {customContent || (
          <>
            <div className="val elipsis">{value}</div>
            <SvgIcon
              className="cursor"
              name="arrow-down"
              width="12"
              height="6"
            />
          </>
        )}
      </div>

      <div
        ref={animateRef}
        className={classnames('option-div', optClassName)}
        style={{ display: slideDown ? 'block' : 'none' }}
      >
        <div className="option-div-inner">
          {options.map((item: SelectOptionProps, index: number) => {
            /** 使用的是key还是value */
            const useKey: boolean = typeof selectedKeys !== 'undefined';
            /** 选中值，类型可能是单个也可能是数组 */
            const selectedKeyorValues = useKey ? selectedKeys : value;
            /** 当前循环要比较的项 */
            const curCompareItem = useKey ? item.key : item.value;
            /** 修复：当multi为true的时候 selectedKeyorValues不是数组的情况导致报错 */
            const visibility: boolean = Array.isArray(selectedKeyorValues)
              ? selectedKeyorValues.includes(curCompareItem)
              : selectedKeyorValues === curCompareItem;
            return (
              <div
                key={index}
                style={optStyle}
                className={classnames('opt flex-between', {
                  ac: visibility,
                })}
                onClick={(e) => {
                  onChange(item.value, item.key);
                  e.stopPropagation();
                  !multi && setSlideDown(false); //多选时选择一个不收起
                }}
              >
                <span className="elipsis" title={item.value}>
                  {item.value}
                </span>
                {customSelectedIcon || (
                  <SvgIcon
                    style={{
                      marginRight: '10px',
                      visibility: visibility ? 'visible' : 'hidden',
                    }}
                    className="cursor"
                    name="yes"
                    width="12"
                    height="8"
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
